class CountdownMessage extends window.BAO.CustomElement() {
  connectedCallback () {
    this.deadline = this.dataset.deadline
    this.message = this.dataset.message
    this.hideAfterEnd = this.dataset.hideAfterEnd === 'true'
    this.afterMessage = this.dataset.afterMessage
    this.separator = this.dataset.separator || ''

    this.showCountdown()
    this.startTimer()
  }

  showCountdown () {
    this.els.message.element.innerHTML = this.message.replace(
      '[countdown]',
      this.getCountdownTemplate(),
    )
    this.setAttribute('aria-hidden', 'false')
  }

  getCountdownTemplate () {
    return `
      <span data-countdown-days></span>
      <span data-countdown-days-label>${window.theme.strings.countdown.days}</span>
      <span data-separator-days-hours></span>
      <span data-countdown-hours></span>
      <span data-countdown-hours-label>${window.theme.strings.countdown.hours}</span>
      <span data-separator-hours-minutes></span>
      <span data-countdown-minutes></span>
      <span data-countdown-minutes-label>${window.theme.strings.countdown.minutes}</span>
      <span data-separator-minutes-seconds></span>
      <span data-countdown-seconds></span>
      <span data-countdown-seconds-label>${window.theme.strings.countdown.seconds}</span>
    `
  }

  startTimer () {
    const deadlineDate = this.parseDeadline(this.deadline)
    this.updateTimer(deadlineDate)
    this.timerInterval = setInterval(() => {
      this.updateTimer(deadlineDate)
    }, 1000)
  }

  parseDeadline (deadline) {
    const [date, time] = deadline.split('|')
    const [day, month, year] = date.split('/').map((part) => part.trim())
    const [hours, minutes, seconds] = time
      .split(':')
      .map((part) => part.trim())

    return new Date(
      `20${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`,
    )
  }

  updateTimer (deadlineDate) {
    const now = new Date()
    const timeRemaining = deadlineDate - now

    if (timeRemaining <= 0) {
      clearInterval(this.timerInterval)
      this.els.message.element.innerHTML = this.afterMessage
      if (this.hideAfterEnd) {
        this.setAttribute('aria-hidden', 'true')
      }
      return
    }

    const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24))
    const hours = Math.floor(
      (timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
    )
    const minutes = Math.floor(
      (timeRemaining % (1000 * 60 * 60)) / (1000 * 60),
    )
    const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000)

    const daysElement = this.els.message.element.querySelector(
      '[data-countdown-days]',
    )
    const hoursElement = this.els.message.element.querySelector(
      '[data-countdown-hours]',
    )
    const minutesElement = this.els.message.element.querySelector(
      '[data-countdown-minutes]',
    )
    const secondsElement = this.els.message.element.querySelector(
      '[data-countdown-seconds]',
    )

    const daysLabelElement = this.els.message.element.querySelector(
      '[data-countdown-days-label]',
    )
    const hoursLabelElement = this.els.message.element.querySelector(
      '[data-countdown-hours-label]',
    )
    const minutesLabelElement = this.els.message.element.querySelector(
      '[data-countdown-minutes-label]',
    )
    const secondsLabelElement = this.els.message.element.querySelector(
      '[data-countdown-seconds-label]',
    )

    const separatorDaysHours = this.els.message.element.querySelector(
      '[data-separator-days-hours]',
    )
    const separatorHoursMinutes = this.els.message.element.querySelector(
      '[data-separator-hours-minutes]',
    )
    const separatorMinutesSeconds = this.els.message.element.querySelector(
      '[data-separator-minutes-seconds]',
    )

    daysElement.textContent = days.toString().padStart(2, '0')
    hoursElement.textContent = hours.toString().padStart(2, '0')
    minutesElement.textContent = minutes.toString().padStart(2, '0')
    secondsElement.textContent = seconds.toString().padStart(2, '0')

    const showDays = days > 0
    const showHours = showDays || hours > 0
    const showMinutes = showHours || minutes > 0

    daysElement.style.display = showDays ? '' : 'none'
    daysLabelElement.style.display = showDays ? '' : 'none'
    separatorDaysHours.style.display = showDays ? '' : 'none'
    hoursElement.style.display = showHours ? '' : 'none'
    hoursLabelElement.style.display = showHours ? '' : 'none'
    separatorHoursMinutes.style.display = showHours ? '' : 'none'
    minutesElement.style.display = showMinutes ? '' : 'none'
    minutesLabelElement.style.display = showMinutes ? '' : 'none'
    separatorMinutesSeconds.style.display = showMinutes ? '' : 'none'
    secondsElement.style.display = '' // Always show seconds
    secondsLabelElement.style.display = '' // Always show seconds

    separatorDaysHours.textContent = this.separator
    separatorHoursMinutes.textContent = this.separator
    separatorMinutesSeconds.textContent = this.separator

    daysLabelElement.textContent =
      days === 1
        ? window.theme.strings.countdown.day
        : window.theme.strings.countdown.days
    hoursLabelElement.textContent =
      hours === 1
        ? window.theme.strings.countdown.hour
        : window.theme.strings.countdown.hours
    minutesLabelElement.textContent =
      minutes === 1
        ? window.theme.strings.countdown.minute
        : window.theme.strings.countdown.minutes
    secondsLabelElement.textContent =
      seconds === 1
        ? window.theme.strings.countdown.second
        : window.theme.strings.countdown.seconds
  }
}

if (!customElements.get('countdown-message')) {
  customElements.define('countdown-message', CountdownMessage)
}
